import React from "react";

const ListingOversightList = React.lazy(() => import('src/pages/listing_oversight/ListingOversightList'));
const ViewListingOversight = React.lazy(() => import('src/pages/listing_oversight/ViewListingOversight'));

const routes = [
    { path: '/dashboard/listing-oversight-list/:param', withParam: true, exact: true, name: "", element: ViewListingOversight },
    { path: '/dashboard/listing-oversight-list', name: 'Listing Oversight', element: ListingOversightList },
];

export default routes;
